import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { ModelLocatorService } from 'src/app/services/config/model-locator.service';

type MenuKey = keyof ModelLocatorService['menu'];

interface LeftMenuItem {
    route: string;
    label: string;
    condition?: MenuKey;
}

@Component({
    selector: 'app-mm-left-column',
    templateUrl: './mm-left-column.component.html',
    styleUrls: ['./mm-left-column.component.scss'],
})
export class MmLeftColumnComponent {

    public profileMenu: LeftMenuItem[] = [
        { route: '/profile', label: 'Meu Perfil' },
        { route: '/activation-pre', label: 'Registrar Vendas', condition: 'pre' },
        { route: '/activation-list', label: 'Minhas Ativações', condition: 'ativacoes' },
        { route: '/quality', label: 'Minha Qualidade', condition: 'qualidade' },
        { route: '/wallet', label: 'Minha Equipe', condition: 'carteira' },
        { route: '/extract', label: 'Meu Extrato', condition: 'extrato' },
        { route: '/my-rescue', label: 'Meus Resgates', condition: 'resgates' },
        { route: '/my-points', label: 'Tabela de Pontos', condition: 'planos' },
        { route: '/my-categories', label: 'Minha Categoria', condition: 'categoria' },
    ];

    constructor(
        public modelLocator: ModelLocatorService,
        public platform: Platform,
        private router: Router
    ) {
    }

    get firstName(): string {
        return this.modelLocator.dadosLogin.nome ? this.modelLocator.dadosLogin.nome.split(' ')[0] : '';
    }

    get showTickets(): boolean {
        const idperfil = this.modelLocator.dadosLogin.idperfil;
        return this.modelLocator.menu.pontuacao && idperfil !== 18 && idperfil !== 19;
    }

    touchGoToRoute(rota: string): void {
        this.router.navigate([rota]);
    }

    /**
     * Returns true if the menu item has no condition or its menu flag is enabled.
     * @param item - left menu item with optional condition key
     */
    getCondition(item: LeftMenuItem): boolean {
        return !item.condition || !!this.modelLocator.menu[item.condition];
    }

}
